import { axios } from '@/utils/request'

const api = {
  complaint: '/order/complaint',
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  street: '/basicdata/street',
  backlog: '/backlog/complaints',
  pendingMatter: '/backlog/pendingMatter',
  complaints: '/backlog/complaints',
  pendingMatter2: '/backlog/pendingMatter',
  pendingMatter3: '/backlog/pendingMatter',
  complaints2: '/backlog/complaints',
  complaint3: '/backlog/complaints',
 // complaints4: '/backlog/complaints',
  complaint5: '/backlog/complaints'
}
export function exportcomplaintOrder (parameter) {
  return axios({
    url: 'order/complaint/excelList',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })

}
// 1.2.12申诉
export function getappeal(parameter) {
  return axios({
    url: 'backlog/complaints/appeal',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.3.9问题反馈开始处理
export function getendProcessing(parameter) {
  return axios({
    url: 'backlog/complaints/end',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
// 回复
export function getreply (parameter) {
  return axios({
    url: api.complaint5 + '/reply',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getprocessingCompleted(parameter) {
  return axios({
    url: 'backlog/complaints/processingCompleted',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}

// 开始处理
export function startProcessing (parameter) {
  return axios({
    url: 'backlog/complaints/startProcessing',
   // url: api.complaint3 + '/startProcessing?' + 'complaintsHeaderId=' + parameter.complaintId,
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 修改处理
export function updateComplaint (parameter) {
  return axios({
    url: api.complaint3 + '/updateComplaint',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 处理详情
export function getComplaintInfo2 (parameter) {
  return axios({
    url:  '/backlog/complaints/getComplaintInfo',
   // url: api.complaints2 + '/getComplaintInfo?' + 'complaintsHeaderId=' + parameter.complaintId ,
    method: 'get',
    params: parameter,
  })
}


export function getPendingMattersResume (parameter) {
  return axios({
    url:  '/backlog/pendingMatter/getPendingMattersResume',
    //  url: api.pendingMatter2 + '/getPendingMattersResume?' + 'pendingMattersRecordId=' + parameter.pendingMattersRecordId + '&matterCode=' + parameter.matterCode,
    method: 'get',
    params: parameter,
  })
}

// 撤回
export function revoke (parameter) {
  return axios({
    url:  '/backlog/complaints/revoke',
    // url: api.complaints + '/revoke?' + 'complaintsHeaderId=' + parameter.complaintsHeaderId ,
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 获取待办事项角色列表
export function getPendingMattersRoleList (parameter) {
  return axios({
    url: api.pendingMatter + '/getPendingMattersRoleList',
    method: 'get',
    params: parameter,
  })
}

// 转派
export function transfer (parameter) {
  return axios({
    url:  '/backlog/complaints/transfer',
    //url: api.backlog + `/transfer?` + 'complaintsHeaderId=' + parameter.complaintId + '&roleCode=' + parameter.roleCode ,
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 获取投诉待办事项类型
export function getPendingMatterMenu (parameter) {
  return axios({
    url:  '/backlog/pendingMatter/getPendingMatterMenu',
   // url: api.pendingMatter3 + '/getPendingMatterMenu?' + 'matterTypeCode=' + parameter.matterTypeCode,
    method: 'get',
    params: parameter,
  })
}

export function selectComplaint (parameter) {
  return axios({
    url:  '/order/complaint/selectComplaint',
    method: 'get',
    params: parameter,
  })
}

// 省
export function selectAllProvince (parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 市
export function selectCityName (parameter) {
  console.log(parameter)
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

 export const complaint = api.complaint + '/export'
